/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

// export const InventoryColumnFormatter = (cellContent, row, rowIndex) => (
//   <>
//     {(cellContent == "custom") ? row.plan_inventory : row.inventory_type} 
//   </>
// );

export const InventoryColumnFormatter = (cellContent, row, rowIndex) => {

  const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  return (
    <>
      {(cellContent !== null) ? row.plan_inventory : titleCase(row.inventory_type)}
    </>
  );
}